
import { useEffect } from 'react';
import HomeCard from '../HomeCard';
import style from './style.module.css';

const HomeLink = props => {

    return (
        <HomeCard title={"Featured"} icon={props.icon} onSelect={props.onSelect}>
            <div className={style.info}>
                <div className={style.content}>
                    {props.children}
                </div>
                <div className={style.secondary + ' home-text-secondary'}>{props.secondary || ''}</div>
            </div>
        </HomeCard>
    );

};

export default HomeLink;
